import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'secondstomins'})
export class SecondsToMins implements PipeTransform {
  transform(value: number): string {
    return(value-(value%=60))/60+(9<value?':':':0')+value
  }
}